import React, { useState } from 'react';
import { ZdsCheckbox, ZdsCheckboxGroup } from '@zig-design-system/ui-components-react';
import { Label } from './elements/Label';
export const Check = ({ field, onChange, value }) => {
    const [checkedBoxes, setCheckedBoxes] = useState(new Set(value));
    const handleChange = (e) => {
        const newCheckedBoxes = new Set([...checkedBoxes]);
        newCheckedBoxes.has(e.target.value)
            ? newCheckedBoxes.delete(e.target.value)
            : newCheckedBoxes.add(e.target.value);
        setCheckedBoxes(newCheckedBoxes);
        onChange(field, Array.from(newCheckedBoxes));
    };
    return (React.createElement(ZdsCheckboxGroup, { required: field.mandatory },
        React.createElement(Label, { field: field }),
        field.modifiedSettings.map((option, index) => (React.createElement(ZdsCheckbox, { onZdsChange: handleChange, key: `powermail_field_${field.marker}_${index}`, id: `powermail_field_${field.marker}_${index}`, value: option.value, checked: checkedBoxes.has(option.value) },
            React.createElement("span", null, option.label))))));
};
